import { Store } from '../types';

export const getLocaleByStore = (store: Store): string | null => {
  if (store.country && store.languages[0]) {
    return `${store.languages[0]}-${store.country}`;
  }

  return null;
};
